<li>
    <div class="header">
        <span class="bar"></span><span class="crinkle"
            ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
            >
                <path
                    d="M1.32395 0.999996L50 49"
                    stroke="#0D0C0C"></path>
            </svg></span
        >
    </div>
    <div class="body">
        <slot />
    </div>
</li>

<style lang="less">
    li {
        flex-grow: 1;
        width: 0px;

        display: flex;
        flex-direction: column;
        .header {
            display: flex;
            height: 48px;

            .bar {
                flex-grow: 1;
                height: 100%;
                border-radius: 2px 0px;
                border-top: 1px solid var(--bg-100);
                border-left: 1px solid var(--bg-100);
            }
            .crinkle {
                width: 48px;
                height: 48px;
                margin-left: -2px;
            }
        }
        .body {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;
            border: 1px solid var(--bg-100);
            border-top: 0px solid black;
            border-radius: 0px 0px 2px 2px;
        }
    }
</style>
